module.exports = __webpack_public_path__ + "img/y_2018_1_hover.8cee5c6b.png";